import React, { useEffect } from 'react';
import { useState } from 'react';
import { Form, Button, Spinner, Col, Modal } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { numberFormat } from '../../../Global/numberFormat';
import LoadingSpinner from '../../../modules/Billing/Components/LoadingSpinner';


const CategoryWiseDivisionRolling = ({ categoryWise, workingDays }) => {

    const dispatch = useDispatch();
    const { register, setValue } = useForm();
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const handleAccordionToggle = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    const regionDataFilter = [{}, {}];
    const currentDate = new Date();
    const initialMonth = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}`;
    const [selectedMonth, setSelectedMonth] = useState(initialMonth);

    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
    };
    console.log('selectedMonth', selectedMonth)

    const divisionDataViews = useSelector(state => state?.mapData?.topTwentTSM?.allData);
    const divisionDataViewIsLoading = useSelector(state => state?.mapData?.topTwentTSMIsLoading);
    const monthNames = [
        "January", "February", "March", "April", "May", "June", "July",
        "August", "September", "October", "November", "December"
    ];
    const monthNumber = categoryWise && categoryWise.length > 0 ? categoryWise[0]?.month : null;
    const monthName = monthNames[monthNumber - 1]; // Adjusting index since array is zero-based

    return (
        <div className='container ims-division-wise-report'>
            <div>
                <div className="dailysales      container-fluid top_card3-map rounded mb-5  p-2">
                    <h1 style={{ width: '48%', margin: 'auto' }}>Category Wise Division Ach {monthName && "("} {monthName} {monthName && ")"}</h1>
                </div>
            </div>
            <div className="table-container">
                <table id="table-to-xls" className="territory-table">
                    <thead className='header-working'>
                        <th>  </th>
                        <th> Working days:  {workingDays?.totWorkingDay}</th>

                        <th></th>
                        <th> Working days Pass: {workingDays?.passWorkingDay}  </th>
                        <th>  </th>
                        <th></th>
                        <th> Need IMS: {workingDays?.imsTarget.toFixed(2)}  %</th>
                        <th></th>

                    </thead>
                    <thead className='forFontstyle'>
                        <tr>
                            <th> SI</th>
                            <th> Division</th>
                            <th>Bis Ach%</th>
                            <th>Cooki Ach% </th>
                            <th>Cake Ach%</th>
                            <th>Wafer Ach%</th>
                            <th>Snacks
                                Ach% </th>
                            <th align='center' >Cum.Ach%
                            </th>

                        </tr>
                    </thead>
                    <tbody className="territory-tr">
                        {categoryWise?.map((item, index) => (
                            <tr key={index}>
                                <td className='text-center-style heigtsetInHeader'>{index + 1}</td>
                                <td className='text-center-style heigtsetInHeader'>{item?.divisionName}</td>
                                <td className='text-center-style heigtsetInHeader'>{numberFormat(item?.bisAch)}%</td>
                                <td className='text-center-style heigtsetInHeader'> {numberFormat(item?.cookiAch)}%</td>
                                <td className='text-center-style heigtsetInHeader'> {item?.cakeAch}%</td>
                                <td className='text-center-style heigtsetInHeader' >{item?.waferAch}%</td>
                                <td className='text-center-style heigtsetInHeader'>{item?.snacksAch}%</td>
                                <td className='text-center-style heigtsetInHeader' > {item?.cumAch}%</td>

                            </tr>
                        ))}

                    </tbody>

                </table>
            </div>


        </div>
    );
};

export default CategoryWiseDivisionRolling;